<template>
    <v-row v-if="machine" no-gutters @click="collapseFunc()">
        <h4 v-if="generalizerText" v-text="generalizerText"
            :class="machine.IsActive ? 'useThemeTextColor' : 'deactivated'" class="mr-1"
            style="font-size: 13.5px !important;">
        </h4>
        <router-link class="onlyshowlinkonhover" :to="{
            name: 'ViewMachine',
            params: { machineId: machine.Id }
        }" style="font-size: 13.5px !important;" :class="machine.IsActive ? 'primary--text' : 'deactivated'">
            {{ identifierText }}
        </router-link>
    </v-row>
    <h4 v-else class="warning--text" @click="collapseFunc()">
        Unlinked
    </h4>
</template>


<script>
import MachineMixin from '@/helpers/Mixins/MachineMixin';

export default {
    name: 'GroupByMachineHeader',
    props: {
        machine: Object,
        collapseFunc: Function
    },
    components: {},
    mixins: [MachineMixin],

    data() {
        return {};
    },

    methods: {},

    computed: {
        generalizerText() {
            return this.machineGeneralizerText(this.machine);
        },
        identifierText() {
            return this.machineIdentifierText(this.machine);
        }
    },

    watch: {},
};
</script>


<style lang='scss' scoped>
.onlyshowlinkonhover:not(:hover) {
    text-decoration: none;
}
</style>